/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IComponentOptions, IFilterService, ILogService} from 'angular';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {TSBemerkungScope} from '../../../models/enums/TSBemerkungScope';
import {getTSBemerkungSichtbarkeitValues, TSBemerkungSichtbarkeit} from '../../../models/enums/TSBemerkungSichtbarkeit';
import TSAbstractBemerkungEntity from '../../../models/TSAbstractBemerkungEntity';
import TSBenutzerBemerkung from '../../../models/TSBenutzerBemerkung';
import TSSystemBemerkung from '../../../models/TSSystemBemerkung';
import TSTransitionBemerkung from '../../../models/TSTransitionBemerkung';
import {RemoveDialogController} from '../../dialog/RemoveDialogController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';
import IScope = angular.IScope;
import IWindowService = angular.IWindowService;

declare let require: any;
declare let angular: any;
let template = require('./dv-bemerkung-list.html');
require('./dv-bemerkung-list.scss');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVBemerkungListComponentConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        systemBemerkungen: '=',
        benutzerBemerkungen: '=',
        transitionBemerkungen: '=',
        scopeToShow: '<',
        schadenfallId: '<',
        readonly: '<',
        disableSystemBemerkung: '<',
        disableTransitionBemerkung: '<',
        disableBenutzerBemerkung: '<',
    };
    template = template;
    controller = DVBemerkungListController;
    controllerAs = 'vm';
}

export class DVBemerkungListController {

    systemBemerkungen: Array<TSSystemBemerkung> = [];
    benutzerBemerkungen: Array<TSBenutzerBemerkung> = [];
    transitionBemerkungen: Array<TSTransitionBemerkung> = [];
    scopeToShow: Array<TSBemerkungScope> = [];
    allBemerkungen: Array<TSAbstractBemerkungEntity> = []; //Liste die im Gui angezeigt wird

    selectedTabIds: string[] = [];
    schadenfallId: string;
    readonly: boolean;
    disableSystemBemerkung: boolean;
    disableTransitionBemerkung: boolean;
    disableBenutzerBemerkung: boolean;

    static $inject: any[] = ['$filter', '$log', 'CONSTANTS', '$scope', 'RoleUtilService', '$window', 'AuthServiceRS', 'DvDialog', 'SchadenfallModelManager'];

    /* @ngInject */
    constructor(private $filter: IFilterService, private $log: ILogService,
                private CONSTANTS: any, private $scope: IScope, private roleUtilService: RoleUtilService,
                private $window: IWindowService,
                private authServiceRS: AuthServiceRS, private dvDialog: DvDialog, private schadenfallModelManager: SchadenfallModelManager,
    ) {

    }

    $onInit() {
        this.initView();

        this.$scope.$watchCollection(() => {
            return this.benutzerBemerkungen;
        }, (newValue, oldValue) => {
            if ((newValue.length !== oldValue.length)) {
                this.initView();
            }
        });

        this.$scope.$watchCollection(() => {
            return this.systemBemerkungen;
        }, (newValue, oldValue) => {
            if ((newValue.length !== oldValue.length)) {
                this.initView();
            }
        });

        this.$scope.$watchCollection(() => {
            return this.transitionBemerkungen;
        }, (newValue, oldValue) => {
            if ((newValue.length !== oldValue.length)) {
                this.initView();
            }
        });

        this.$scope.$watch(() => {
            return this.disableTransitionBemerkung;
        }, (newValue, oldValue) => {
            if ((newValue !== oldValue)) {
                this.initView();
            }
        });

        this.$scope.$watch(() => {
            return this.disableSystemBemerkung;
        }, (newValue, oldValue) => {
            if ((newValue !== oldValue)) {
                this.initView();
            }
        });

        this.$scope.$watch(() => {
            return this.disableBenutzerBemerkung;
        }, (newValue, oldValue) => {
            if ((newValue !== oldValue)) {
                this.initView();
            }
        });
    }

    private initView() {
        // Bemerkungen zusammenführen
        this.allBemerkungen = [];
        if (!this.disableSystemBemerkung && this.systemBemerkungen && this.systemBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.systemBemerkungen);
        }
        if (!this.disableBenutzerBemerkung && this.benutzerBemerkungen && this.benutzerBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.benutzerBemerkungen);
        }
        if (!this.disableTransitionBemerkung && this.transitionBemerkungen && this.transitionBemerkungen.length > 0) {
            this.allBemerkungen = this.allBemerkungen.concat(this.transitionBemerkungen);
        }

        this.allBemerkungen = this.allBemerkungen.sort((n1, n2) => {

            if (n1.timestampErstellt && n2.timestampErstellt) {

                if (n1.timestampErstellt > n2.timestampErstellt) {
                    return -1;
                }

                if (n1.timestampErstellt < n2.timestampErstellt) {
                    return 1;
                }
            }
            return 0;
        });

        if (this.scopeToShow && this.scopeToShow.length > 0) {
            this.allBemerkungen = this.allBemerkungen.filter((n1) => {
                return this.scopeToShow.indexOf(n1.getBemerkungScope()) > -1;
            });
        }

        // show two messages as default
        this.selectedTabIds = [];
        this.allBemerkungen.forEach((bm) => this.selectedTabIds.push(bm.id));
    }

    private getTSBemerkungSichtbarkeitValues(): Array<TSBemerkungSichtbarkeit> {
        return getTSBemerkungSichtbarkeitValues();
    }

    private isSichtbarkeitVisible(sichtbarkeit: any): boolean {
        if (sichtbarkeit === TSBemerkungSichtbarkeit.FONDSSUISSE) {
            return this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles());
        }
        return true;
    }

    public isMine(bemerkung: TSAbstractBemerkungEntity): boolean {
        let principal = this.authServiceRS.getPrincipal();
        let besitzer = bemerkung.getBesitzer();
        if (besitzer && principal && principal.email) {
            return principal.email === besitzer.email;
        }
        return false;
    }

    public isDeleteAllowed(bemerkung: TSAbstractBemerkungEntity): boolean {
        return bemerkung instanceof TSBenutzerBemerkung;
    }

    public isInStatusALLE(status: any): boolean {
        return status === TSBemerkungSichtbarkeit.ALLE;
    }

    public deleteBemerkung(bemerkung: TSAbstractBemerkungEntity, event: any): void {
        this.dvDialog.showDialog(removeDialogTemplate, RemoveDialogController, {
            text: '',
            title: 'BEMERKUNG_REMOVE',
        }).then(() => {   //User confirmed removal
            this.schadenfallModelManager.removeBemerkung(bemerkung, this.schadenfallId);
            this.initView();
        }).catch(() => {
        });
    }

    public editBemerkung(bemerkung: TSAbstractBemerkungEntity, event: any): void {
        bemerkung.editMode = true;
    }

    public saveBemerkung(bemerkung: TSBenutzerBemerkung) {
        if (bemerkung && this.schadenfallId) {
            this.schadenfallModelManager.saveBemerkung(bemerkung, this.schadenfallId).then((schadResp: TSBenutzerBemerkung) => {
                bemerkung.editMode = false;
            });
        } else {
            this.$log.debug('bemerkung or schadenfallId was not found');
        }
    }

    public displayScopeForType(message: TSAbstractBemerkungEntity): boolean {
        return !(message instanceof TSTransitionBemerkung);

    }
}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-bemerkung-list/dv-bemerkung-list.ts